(() => {
  if (window.sudoraFooterInitialized) return;
  window.sudoraFooterInitialized = true;
  const desktop = window.matchMedia('(min-width: 769px)');

  function applyLayout(root) {
    root.querySelectorAll('[data-footer-menu]').forEach((menu) => {
      menu.open = desktop.matches;
      menu.toggleAttribute('data-desktop', desktop.matches);
      const summary = menu.querySelector('summary');
      if (desktop.matches) summary.setAttribute('tabindex', '-1');
      else summary.removeAttribute('tabindex');
    });
  }

  function initialize(root) {
    root.querySelectorAll('[data-sudora-footer]').forEach((footer) => {
      if (footer.dataset.footerReady) return;
      footer.dataset.footerReady = 'true';
      footer.querySelectorAll('[data-footer-menu] summary').forEach((summary) => {
        summary.addEventListener('click', (event) => {
          if (desktop.matches) event.preventDefault();
        });
      });
      applyLayout(footer);
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  const updateLayout = () => {
    document.querySelectorAll('[data-sudora-footer]').forEach(applyLayout);
  };
  if (desktop.addEventListener) desktop.addEventListener('change', updateLayout);
  else desktop.addListener(updateLayout);
})();
